import React, {Component} from "react";
import "./App.scss";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import {getUserDataFromBackend, log, NullableType} from "./Tools";
import {AnyAction, bindActionCreators, Dispatch} from "redux";
import {connect} from "react-redux";
import {isReturnFromPayment, loginImageStatus} from "./PureTools";
import * as actions from './actions/action';
import {FlightType, LoginType} from './actions/action';
import {LocationsType, StateBaseType} from "./store";
import LMap from "./LMap";
import CityHover from "./CityHover";
import FlightHover from "./FlightHover";
import openingPic from './dot.jpg';
import Loader from "./Loader";

interface InputType {
    /* from parent */
}

interface StateType {
    /* from redux props mapping*/
    spinner: boolean,
    veil: boolean,
    editFlightNumber: number,
    isFilter: boolean,
    showTableNumber: number,
    showMenu: boolean,
    showAddAirline: boolean,
    showCharts: number,
    showGlobe: number,
    showStats: boolean,
    showShowcase: NullableType<FlightType>,
    showTutorial: boolean,
    showSettings: boolean,
    showWhatsNew: boolean,
    showRegister: boolean,
    showReset: boolean,
    showVerify: boolean,
    showMatrix: boolean,
    showConsent: boolean,
    showPolicy: boolean,
    incompleteQueue: string[],
    flights: FlightType[],
    locations: LocationsType,
    allFlightsLength: number,
    showLogin: boolean,
    mapType: number,
    user: NullableType<LoginType>,
    mapReferenceGoogle: any,
    mapReferenceLeaflet: any,
    mapZoomGoogle: number,
    mapZoomLeaflet: number,
    showSearch: boolean,
    showFeedback: boolean,
    showMapSelection: boolean,
    filterApplied: boolean,
    welcomeState: number,
}

interface DispatchType {
    /* from redux actions*/
    resize: typeof actions.resize,
    jumpToMap: typeof actions.jumpToMap,
    toggleCharts: typeof actions.toggleCharts,
    toggleShowcase: typeof actions.toggleShowcase,
    toggleGlobe: typeof actions.toggleGlobe,
    toggleStats: typeof actions.toggleStats,
    toggleMapSelection: typeof actions.toggleMapSelection,
    toggleSettings: typeof actions.toggleSettings,
    toggleRegister: typeof actions.toggleRegister,
    toggleVerify: typeof actions.toggleVerify,
    toggleMatrix: typeof actions.toggleMatrix,
    toggleEdit: typeof actions.toggleEdit,
    toggleFilter: typeof actions.toggleFilter,
    toggleTables: typeof actions.toggleTables,
    toggleConsent: typeof actions.toggleConsent,
    login: typeof actions.login,
    logout: typeof actions.logout,
    enqueue: typeof actions.enqueue,
    dequeue: typeof actions.dequeue,
}

type PropsType = InputType & StateType & DispatchType;


interface MainState {
    forceLineRender: any,
    showModal: boolean,
    email: string,
    password: string,
    showPassword: boolean,
    message: NullableType<string>,
}

class App extends Component<PropsType, MainState> {

    constructor(props: PropsType) {
        super(props);

        this._update = this._update.bind(this);
        this._showcaseFlight = this._showcaseFlight.bind(this);
        this._login = this._login.bind(this);
        this._getMeasurements = this._getMeasurements.bind(this);
        //this._updateFlightTimezones = this._updateFlightTimezones.bind(this);
        this._setParentForceLineRender = this._setParentForceLineRender.bind(this);

        this.state = {
            forceLineRender: null,
            showModal: isReturnFromPayment,
            email: '',
            password: '',
            showPassword: false,
            message: null,
        };

        this._login();
    }

    shouldComponentUpdate(nextProps: any, nextState: any) {
        log('should app update');
        return true;
    }

    _update() {
        if (this.props.showCharts > -1) {
            this.props.toggleCharts(-1);
        }
        this.props.resize();
        this.forceUpdate();
    }

    componentDidMount() {
        window.addEventListener("resize", this._update);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this._update);
    }


    _showcaseFlight(flight: NullableType<actions.FlightType>) {
        log('showcase');
        if (this.props.showGlobe > -1 ||
            this.props.showTableNumber > -1 ||
            this.props.showCharts > -1 ||
            this.props.editFlightNumber > -1) {
            log('other page open, skipping showcase');
        } else {
            this.props.toggleShowcase(flight);
        }
    }


    _login() {
        log('login');

        //eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImRlbW8iLCJpc1N1cGVyIjpmYWxzZSwibGV2ZWwiOiJmcmVlIiwiaWF0IjoxNjg0MzYxNzM0LCJleHAiOjI2MzEwODk3MzR9.8wjhqHkJGnjP2qjMcua5B2OvwOMSVZ5HqcFlMeXM9Pc
        const token = window.location.pathname.split('token/')[1];

        if (token) {
            this.props.login({
                email: "demo",
                level: "gold",
                isSuper: false,
                consent: true,
                km: true,
                celsius: true,
                homeAirport: "hel",
                images: true,
                dateFormat: "en-gb",
                token
            });
            getUserDataFromBackend(token);
        } else {
            window.location.href = 'https://flightlogmap.com';
        }
    }

    _getMeasurements() {
        return document.getElementById('appDiv')!.getBoundingClientRect();
    }

    _setParentForceLineRender(func: any) {
        this.setState({
            forceLineRender: func
        });
    }


    render() {
        log('render app');

        let lmap, spinner;

        spinner =
            <Loader enabled={this.props.spinner}
                    text={this.props.incompleteQueue.length ? this.props.incompleteQueue[0] : ''}/>;

        lmap = <LMap
            mapZoom={3}
            setParentForceLineRender={this._setParentForceLineRender}
        />;

        return (
                <div id="appDiv" className={'App'}>

                    {spinner}

                    <img className="hiddenImage" src={openingPic} alt="hidden" onLoad={() => {loginImageStatus.loaded = true}} />

                    <div className="appTitle" onClick={()=>{window.location.href = 'https://flightlogmap.com';}}>FlightLogMap</div>

                    <div className="App-header">

                        {lmap}

                        <CityHover/>

                        <FlightHover/>


                    </div>

                </div>
        );
    }
}

const mapStateToProps = (state: StateBaseType) => {
    log('mapstatetoprops', state);

    return {
        spinner: state.reducer.spinner,
        veil: state.reducer.veil,
        editFlightNumber: state.reducer.editFlightNumber,
        isFilter: state.reducer.isFilter,
        showTableNumber: state.reducer.showTableNumber,
        showMenu: state.reducer.showMenu,
        showAddAirline: state.reducer.showAddAirline,
        showCharts: state.reducer.showCharts,
        showGlobe: state.reducer.showGlobe,
        showStats: state.reducer.showStats,
        showShowcase: state.reducer.showShowcase,
        showTutorial: state.reducer.showTutorial,
        showSettings: state.reducer.showSettings,
        showWhatsNew: state.reducer.showWhatsNew,
        incompleteQueue: state.reducer.incompleteQueue,
        flights: state.reducer.flights,
        locations: state.reducer.locations,
        allFlightsLength: state.reducer.allFlights.length,
        showLogin: state.reducer.showLogin,
        mapType: state.reducer.mapType,
        user: state.reducer.user,
        mapReferenceGoogle: state.reducer.mapReferenceGoogle,
        mapReferenceLeaflet: state.reducer.mapReferenceLeaflet,
        mapZoomGoogle: state.reducer.mapZoomGoogle,
        mapZoomLeaflet: state.reducer.mapZoomLeaflet,
        showSearch: state.reducer.showSearch,
        showRegister: state.reducer.showRegister,
        showReset: state.reducer.showReset,
        showVerify: state.reducer.showVerify,
        showMatrix: state.reducer.showMatrix,
        showConsent: state.reducer.showConsent,
        showPolicy: state.reducer.showPolicy,
        showFeedback: state.reducer.showFeedback,
        showMapSelection: state.reducer.showMapSelection,
        filterApplied: state.reducer.filterApplied,
        welcomeState: state.reducer.welcomeState,
    }
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators<any, any>(actions, dispatch);
};

export default connect<StateType, DispatchType, InputType, StateBaseType>(mapStateToProps, mapDispatchToProps)(App);
